/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SSOUXMode } from './SSOUXMode';
import {
    SSOUXModeFromJSON,
    SSOUXModeFromJSONTyped,
    SSOUXModeToJSON,
    SSOUXModeToJSONTyped,
} from './SSOUXMode';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface SAMLMethodOptions
 */
export interface SAMLMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof SAMLMethodOptions
     */
    method: FactorMethod;
    /**
     * 
     * @type {string}
     * @memberof SAMLMethodOptions
     */
    provider_credentials_id: string;
    /**
     * 
     * @type {SSOUXMode}
     * @memberof SAMLMethodOptions
     */
    ux_mode?: SSOUXMode;
    /**
     * URL to redirect to after login at the third-party IdP.
     * @type {string}
     * @memberof SAMLMethodOptions
     */
    redirect_target?: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLMethodOptions
     */
    pkce_code_challenge?: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLMethodOptions
     */
    csrf_token?: string;
}



/**
 * Check if a given object implements the SAMLMethodOptions interface.
 */
export function instanceOfSAMLMethodOptions(value: object): value is SAMLMethodOptions {
    if (!('method' in value) || value['method'] === undefined) return false;
    if (!('provider_credentials_id' in value) || value['provider_credentials_id'] === undefined) return false;
    return true;
}

export function SAMLMethodOptionsFromJSON(json: any): SAMLMethodOptions {
    return SAMLMethodOptionsFromJSONTyped(json, false);
}

export function SAMLMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAMLMethodOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
        'provider_credentials_id': json['provider_credentials_id'],
        'ux_mode': json['ux_mode'] == null ? undefined : SSOUXModeFromJSON(json['ux_mode']),
        'redirect_target': json['redirect_target'] == null ? undefined : json['redirect_target'],
        'pkce_code_challenge': json['pkce_code_challenge'] == null ? undefined : json['pkce_code_challenge'],
        'csrf_token': json['csrf_token'] == null ? undefined : json['csrf_token'],
    };
}

export function SAMLMethodOptionsToJSON(json: any): SAMLMethodOptions {
    return SAMLMethodOptionsToJSONTyped(json, false);
}

export function SAMLMethodOptionsToJSONTyped(value?: SAMLMethodOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': FactorMethodToJSON(value['method']),
        'provider_credentials_id': value['provider_credentials_id'],
        'ux_mode': SSOUXModeToJSON(value['ux_mode']),
        'redirect_target': value['redirect_target'],
        'pkce_code_challenge': value['pkce_code_challenge'],
        'csrf_token': value['csrf_token'],
    };
}

